import type { FC } from 'react';
import { Sessions } from '@/components/sessions/index.tsx';

export const SessionsPage: FC = () => <Sessions />;
